<template>
  <section class="uploadWordPage">
    <popup v-show="isShowUploadWord" bread="教材管理,课程管理,设置主题资料,编辑字母" title="编辑字母" @onBack="popup_back">
      <template slot="button">
        <el-button type="success" @click="saveUploadWord">保存并上传</el-button>
      </template>
      <infoUpDown :bread="'编辑字母'">
        <h3 class="group-tit">字母资料</h3>
        <commonEditWord
          ref="ref_commonUploadWord"
          :key="timestamp"
          :max-number="(26-currentNumber)"
          :form.sync="uploadForm"
          code="dc"
          @formChange="commonUploadWordChange"
        />
      </infoUpDown>
    </popup>
  </section>
</template>

<script>
import commonEditWord from '../components/commonEditWord.vue'
import { mapState } from 'vuex'
import _ from 'lodash'
import { editBasicMeans, addBasicMeans } from '@api/courseManagement/api_setThemeData'
import { functionData } from '../../../../utils/reg'
// import { applyData, findApplyHistory } from '@/api/refund/refundApply'
export default {
  components: {
    commonEditWord
  },
  props: {
    currentNumber: {
      type: Number,
      default: 0
    },
    timestamp: {
      type: Number,
      default: 0
    },
    themeRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isShowUploadWord: false,
      commonUploadForm: {},
      uploadForm: {
        wordList: []
      }
    }
  },
  computed: {
    ...mapState('settingThemeData', ['editLetterList'])
  },

  watch: {
    timestamp: function (val) {
      this.isShowUploadWord = true
      this.dataChange()
    }
  },
  created () {

  },
  methods: {
    // 返回
    dataChange() {
      const array = []
      this.editLetterList.forEach(e => {
        const item = {
          voice: functionData(e, 'pronunciation', 'Pronunciation'),
          img: functionData(e, 'cardChart', 'CardChart'),
          video: functionData(e, 'mouthShape', 'MouthShape'),
          wordName: e.wordName,
          id: e.id
        }
        array.push(item)
      })

      this.uploadForm.wordList = _.cloneDeep(array)
    },
    popup_back () {
      this.isShowUploadWord = false
      // this.$emit('resetFetchData')
    },
    commonUploadWordChange (form) {
      this.commonUploadForm = form
    },
    async saveUploadWord () {
      if (!this.$refs.ref_commonUploadWord.validateForm()) {
        return false
      }
      console.log(this.uploadForm)
      const params = []
      for (const item of this.uploadForm.wordList) {
        params.push({
          wordName: item.wordName,
          cardChartName: item.img[0].paramsFileName || item.img[0].fileName,
          cardChartPath: item.img[0].matchPathName || item.img[0].paramsUrl,
          pronunciationName: item.voice[0].paramsFileName || item.voice[0].fileName,
          pronunciationPath: item.voice[0].matchPathName || item.voice[0].paramsUrl,
          mouthShapeName: item.video[0].paramsFileName || item.video[0].fileName,
          mouthShapePath: item.video[0].matchPathName || item.video[0].paramsUrl,
          teachingThemeId: this.themeRow.id,
          del: true,
          id: item.id,
          select: true,
          basicCode: 'LETTER',
          meansType: 9,
          isUse: 0
        })
      }
      console.log(params)
      try {
        await Promise.all(params.map(async (item) => {
          // 等待异步操作完成，返回执行结果
          if (item.id) {
            return await editBasicMeans({ basicMeansList: [item] })
          } else {
            return await addBasicMeans({ basicMeansList: [item] })
          }
        }))
        this.isShowUploadWord = false
        this.$emit('resetFetchData')
        this.$message.success('添加成功')
      } catch (e) {
        this.$message.closeAll()
        this.$message.error(e)
      }
    }
  }
}
</script>

<style lang='scss'>
.uploadWordPage{
  .group-tit{
    margin: 24px 0;color:#53402B;display: flex;
    align-items: center;
    span{color: #898884;}
    &::before{
      content: '';
      width: 6px;
      height: 22px;
      display: inline-block;
      background: #FCDA6F;
      margin-right: 8px;
      border-radius: 9px;
    }
  }
}
.upload-form-self{
  display: flex;
  flex-wrap: wrap;
  .el-form-item{
    width: 40%;
    &:nth-child(odd){
      margin-right: 10%;
    }
  }
}
</style>
